import React from "react"
import { SectionTitle, DataTable, PaginationControls, StatusBadge } from "../components"
import { cardStyle, loadingStyle } from "../styles/commonStyles"
import { formatThaiBuddhistDate } from "../../../libs/dateUtils"
import { getPaginationInfo } from "../utils/helpers"

const NotiLogsTab = ({ data: notiLogs, loading, currentPage, totalPages, totalCount, perPage, fetchData, id }) => {
	const { indexOfFirstItem } = getPaginationInfo(currentPage, perPage, totalCount)

	const handlePageChange = (page) => {
		fetchData(id, page)
	}

	const headers = ["#", "วันที่สร้าง", "ข้อความ", "Link", "สถานะ"]

	const rows = (notiLogs || []).map((notification, index) => [
		`${indexOfFirstItem + index}.`,
		formatThaiBuddhistDate(notification.create_date),
		notification.message,
		notification.urlLink ? (
			<a key="link" href={notification.urlLink} target="_blank" rel="noopener noreferrer" style={{ color: "#1976d2", textDecoration: "underline" }}>
				{notification.urlLink}
			</a>
		) : (
			"-"
		),
		<StatusBadge key="read-status" status={notification.isRead ? "read" : "unread"} customText={notification.isRead ? "อ่านแล้ว" : "ยังไม่อ่าน"} />,
	])

	return (
		<div className="card-style" style={cardStyle}>
			<SectionTitle title="ประวัติการแจ้งเตือน" />

			{loading && (
				<div
					style={{
						...loadingStyle,
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						background: "rgba(255,255,255,0.8)",
						zIndex: 10,
					}}
				>
					กำลังโหลด...
				</div>
			)}

			<div style={{ position: "relative", opacity: loading ? 0.6 : 1 }}>
				<DataTable headers={headers} rows={rows} emptyMessage="ไม่พบข้อมูลการแจ้งเตือน" />

				{totalPages > 1 && (
					<PaginationControls
						currentPage={currentPage}
						totalPages={totalPages}
						totalCount={totalCount}
						perPage={perPage}
						isLoading={loading}
						onPageChange={handlePageChange}
					/>
				)}
			</div>
		</div>
	)
}

export default NotiLogsTab
